/*
  innvolo-preguntas.js
  Convierte la lista de paneles de preguntas en «índice + panel»: fabrica un
  botón por cada respuesta, lo coloca justo delante de ella y deja visible una
  sola a la vez.

  POR QUÉ EL BOTÓN SE FABRICA AQUÍ
  La sección renderiza sus bloques con `{% content_for 'blocks' %}`, que los
  imprime enteros y seguidos. Liquid no puede sacar el título de cada bloque
  para pintarlo aparte en la columna del índice, así que el reparto se hace
  sobre el DOM ya renderizado. Ver la cabecera de la sección.

  SIN ESTE ARCHIVO LA SECCIÓN SIGUE SIRVIENDO
  Los paneles quedan apilados y todos abiertos. La marca `data-innvolo-listo`
  la pone este script, y es la que activa la maqueta de dos columnas: si el
  script no llega a correr, el CSS no esconde nada.

  MÓVIL
  No hay código aparte. El DOM queda intercalado —botón, su panel, botón, su
  panel—, que es justo el orden de un acordeón; por debajo de 860 px el CSS
  anula la colocación por líneas y ya está.

  ACORDEÓN, NO PESTAÑAS
  Se usa `aria-expanded` + `aria-controls` y no el patrón `tablist`. Un
  `role="tablist"` solo admite pestañas como hijas, y aquí el contenedor de la
  rejilla aloja los botones **y** los paneles: declararlo pestañas sería
  mentirle al lector de pantalla sobre la estructura.
*/

(function () {
  'use strict';

  function monta(caja) {
    if (!caja || caja.dataset.innvoloListo === 'si') return;

    var paneles = Array.prototype.filter.call(caja.children, function (hijo) {
      return hijo.hasAttribute('data-innvolo-pregunta');
    });
    if (!paneles.length) return;

    var tabs = [];

    paneles.forEach(function (panel, i) {
      var rotulo = panel.querySelector('[data-innvolo-preg-t]');
      var texto = rotulo ? rotulo.textContent.trim() : 'Pregunta ' + (i + 1);

      /* El panel ya trae id desde Liquid; si faltara, se le pone uno para que
         `aria-controls` no apunte al vacío. */
      if (!panel.id) panel.id = 'innvolo-preg-' + i;

      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'innvolo-preg__tab';
      tab.id = panel.id + '-tab';
      tab.textContent = texto;
      tab.setAttribute('data-innvolo-preg-tab', '');
      tab.setAttribute('aria-controls', panel.id);
      tab.setAttribute('aria-expanded', 'false');

      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', tab.id);

      caja.insertBefore(tab, panel);
      tabs.push(tab);
    });

    /* Cuántas filas necesita el índice. El CSS añade una fila flexible más al
       final para que el alto sobrante del panel no separe los botones. */
    caja.style.setProperty('--innvolo-preg-n', paneles.length);

    function abre(indice) {
      paneles.forEach(function (panel, i) {
        var activo = i === indice;
        panel.hidden = !activo;
        tabs[i].setAttribute('aria-expanded', activo ? 'true' : 'false');
      });
    }

    caja.addEventListener('click', function (ev) {
      var tab = ev.target.closest('[data-innvolo-preg-tab]');
      if (!tab) return;
      var i = tabs.indexOf(tab);
      if (i !== -1) abre(i);
    });

    /* En el personalizador, seleccionar un bloque abre su respuesta. Sin esto
       el dueño edita una pregunta que no puede ver. */
    caja.addEventListener('innvolo:abre', function (ev) {
      var i = paneles.indexOf(ev.detail);
      if (i !== -1) abre(i);
    });

    abre(0);
    caja.dataset.innvoloListo = 'si';
  }

  function montaTodo(raiz) {
    (raiz || document).querySelectorAll('[data-innvolo-preguntas]').forEach(monta);
  }

  montaTodo();

  document.addEventListener('shopify:section:load', function (ev) {
    montaTodo(ev.target);
  });

  document.addEventListener('shopify:block:select', function (ev) {
    var panel = ev.target.closest('[data-innvolo-pregunta]');
    if (!panel) return;
    var caja = panel.closest('[data-innvolo-preguntas]');
    if (caja) caja.dispatchEvent(new CustomEvent('innvolo:abre', { detail: panel }));
  });
})();
